import {
    SET_EXAM,
    SET_IS_FETCHING,
    SET_CHANGING_PAGE,
    SET_SENDING,
    SET_ERROR,
    SET_MESSAGE,
    SET_ALERT,
    GET_EXAM,
    SEEN_INDUCTION,
    SENDING,
    ERROR_EXAM,
    SET_VERIFY
} from './types'

const ExamReducer = (state, action) => {
    switch (action.type) {
        case SET_EXAM:
            return {
                ...state,
                exam: action.payload
            }
        case SET_IS_FETCHING:
            return {
                ...state,
                isFetching: action.payload
            }
        case SET_CHANGING_PAGE:
            return {
                ...state,
                changingPage: action.payload
            }
        case SET_SENDING:
            return {
                ...state,
                sending: action.payload
            }
        case SET_ERROR:
            return {
                ...state,
                error: action.payload
            }
        case SET_MESSAGE:
            return {
                ...state,
                message: action.payload
            }
        case SET_ALERT:
            return {
                ...state,
                alert: action.payload
            }
        case SET_VERIFY:
            return {
                ...state,
                verify: action.payload
            }
        case GET_EXAM:
            return {
                ...state,
                exam: action.payload,
                isFetching: false,
                error: false,
                message: ''
            }
        case SEEN_INDUCTION:
            return {
                ...state,
                sending: false,
                error: false,
                message: ''
            }
        case SENDING:
            return {
                ...state,
                sending: true,
                error: false,
                message: ''
            }
        case ERROR_EXAM:
            return {
                ...state,
                isFetching: false,
                sending: false,
                error: true,
                message: action.payload || 'Ha ocurrido un error'
            }
        default:
            return state
    }
}
export default ExamReducer